import React from 'react';

const NothingSelected = () => {
  return <div className="nothing__main-content animate__animated animate__fadeInRight">
    <p>
      Select something <br/>
      pr create an entry!
    </p>
    <i className="far fa-star fa-4x mt-5"></i>
  </div>
};

export default NothingSelected;
